import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

import { SupportAtHomeFundingTypes } from '~constants/maps';

export const selectClientPackages = ({ main }: RootState) => main.clientPackages.rows;

export const selectLookupClientPackages = createSelector(selectClientPackages, (rows) =>
  rows.map(({ id, name }) => ({
    id,
    name,
  })),
);

export const selectLookupSahQuarterlyClientPackages = createSelector(selectClientPackages, (rows) =>
  rows
    .filter((pkg) => pkg.funding_type?.sah_code === SupportAtHomeFundingTypes.SAH_QUARTERLY_CLIENT)
    .map(({ id, name }) => ({ id, name })),
);
